import { PricingSection } from "../pricing/PricingSection";
import { posthog } from "../../lib/posthog";
import { howItWorksContent as content } from "../../generated/how-it-works";
import { MarketingFooter, MarketingHeader } from "../public/MarketingChrome";

export function HowItWorksPage() {
  return (
    <div className="app-shell guide-shell oasis-marketing-shell">
      <MarketingHeader current="guide" />

      <main>
        <section className="guide-hero">
          <div className="guide-hero-copy">
            <p className="eyebrow">How Doorway works</p>
            <h1>{content.hero.title}</h1>
            <p className="hero-intro">{content.hero.intro}</p>
            <div className="landing-actions">
              <a className="primary-button" href="/manage" onClick={() => posthog.capture("guide_publish_clicked")}>Publish an app</a>
              <a className="secondary-button" href="#frameworks">Check your framework</a>
            </div>
          </div>
          <figure className="guide-hero-visual">
            <img
              src="/assets/website/doorway-how-it-works-visual.png"
              alt="A folder on your Mac moving through Doorway's safety check to a live madewithdoorway.com link."
              width="1404"
              height="1364"
            />
          </figure>
        </section>

        <section className="guide-section guide-steps" aria-labelledby="guide-steps-heading">
          <div className="guide-section-heading">
            <p className="eyebrow">The whole journey</p>
            <h2 id="guide-steps-heading">Four small steps from folder to link.</h2>
          </div>
          <ol>
            {content.steps.map((step) => (
              <li key={step.number}>
                <span>{step.number}</span>
                <div><h3>{step.title}</h3><p>{step.copy}</p></div>
              </li>
            ))}
          </ol>
        </section>

        <section className="guide-section guide-skills" aria-labelledby="guide-skills-heading">
          <div className="guide-skills-copy">
            <p className="eyebrow">Team Skills</p>
            <h2 id="guide-skills-heading">{content.skills.title}</h2>
            <p>{content.skills.intro}</p>
          </div>
          <div className="guide-skills-flow" aria-hidden="true">
            <div><span>01</span><strong>Publish one skill</strong></div>
            <i>→</i>
            <div><span>02</span><strong>Share the approved version</strong></div>
            <i>→</i>
            <div><span>03</span><strong>Keep everyone current</strong></div>
          </div>
        </section>

        <section className="guide-section guide-safety" aria-labelledby="guide-safety-heading">
          <div className="guide-safety-copy">
            <p className="eyebrow">A safer front door</p>
            <h2 id="guide-safety-heading">Your working app goes online. Your private setup stays home.</h2>
            <p>{content.safety.intro}</p>
          </div>
          <div className="guide-safety-cards">
            {content.safety.cards.map((card, index) => (
              <article key={card.title}>
                <span className={`guide-status ${index === 0 ? "guide-status-go" : "guide-status-stay"}`}>{card.status}</span>
                <h3>{card.title}</h3>
                <p>{card.copy}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="guide-section guide-ai" aria-labelledby="guide-ai-heading">
          <div className="guide-ai-key" aria-hidden="true"><span /><i /></div>
          <div>
            <p className="eyebrow">AI apps stay yours</p>
            <h2 id="guide-ai-heading">{content.ai.title}</h2>
            <p>{content.ai.intro}</p>
            <ul>
              {content.ai.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}
            </ul>
          </div>
        </section>

        <section className="guide-section guide-frameworks" id="frameworks" aria-labelledby="frameworks-heading">
          <div className="guide-section-heading guide-framework-heading">
            <div>
              <p className="eyebrow">Static framework support</p>
              <h2 id="frameworks-heading">Frameworks Doorway can open today.</h2>
            </div>
            <p>{content.frameworks.intro}</p>
          </div>
          <div className="framework-table-wrap">
            <table className="framework-table">
              <thead><tr><th>Framework</th><th>Doorway finds</th><th>Mode</th></tr></thead>
              <tbody>
                {content.frameworks.entries.map((framework) => (
                  <tr key={framework.name}><th scope="row">{framework.name}</th><td><code>{framework.output}</code></td><td>{framework.mode}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
          <aside className="framework-boundary">
            <strong>{content.boundary.title}</strong>
            <p>{content.boundary.intro}</p>
          </aside>
        </section>

        <section className="guide-section guide-frameworks" aria-labelledby="support-roadmap-heading">
          <div className="guide-section-heading guide-framework-heading">
            <div>
              <p className="eyebrow">Growing carefully</p>
              <h2 id="support-roadmap-heading">{content.roadmap.title}</h2>
            </div>
            <p>{content.roadmap.intro}</p>
          </div>
          <div className="framework-table-wrap">
            <table className="framework-table">
              <thead><tr><th>Capability</th><th>Direction</th><th>What keeps it safe</th></tr></thead>
              <tbody>
                {content.roadmap.items.map((item) => (
                  <tr key={item.capability}>
                    <th scope="row">{item.capability}</th>
                    <td>{item.direction}</td>
                    <td>{item.requiredBoundary}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <PricingSection variant="oasis" eyebrow="Simple plans" heading="Pick the door that fits." />

        <section className="guide-cta" aria-labelledby="guide-cta-heading">
          <div><p className="eyebrow">Ready when the app is</p><h2 id="guide-cta-heading">Open the door while the idea is fresh.</h2></div>
          <a className="primary-button" href="/manage" onClick={() => posthog.capture("guide_publish_clicked", { location: "footer" })}>Publish your app</a>
        </section>
      </main>

      <MarketingFooter />
    </div>
  );
}
